import * as React from 'react';

import * as Styles from './ImageAsBackground.module.scss';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
    src: string;
    className?: string;
}

export const ImageAsBackground: React.FC<Props> = (props) => {
    const {src, className, ...rest} = props;

    return (
        <div className={className} {...rest}>
            <div className={Styles['image']} style={{backgroundImage: `url('${src}')`}} />
        </div>
    );
};
